"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const font = {
    sizeXs: '13px',
    sizeSm: '15px',
    sizeMd: '19px',
    sizeLg: '24px',
    sizeXl: '36px',
    sizeXxl: '45px',
    weightDefault: 400,
    weightAttention: 600,
    weightAttentionMax: 700,
    lineHeightXs: '18px',
    lineHeightSm: '24px',
    lineHeightMd: '28px',
    lineHeightLg: '32px',
    lineHeightXl: '48px',
    lineHeightXxl: '64px',
    /* eslint-disable */
    family: "'Nunito', 'Helvetica Neue', Helvetica, Arial, sans-serif",
    /* eslint-enable */
};
exports.default = font;
